import { AxiosResponse } from "axios";
import { ApiResponse } from "../common/type";
import axiosClient from "./axiosClient";

const availableTimeApi = {
    addAvailableTime: async (data: any): Promise<ApiResponse<any>> => {
        return axiosClient.post('/user/available-times', data);
    },
    getAvailableTime: async (): Promise<
        AxiosResponse<ApiResponse<any>>
    > => {
        return axiosClient.get<ApiResponse<any>>(
            '/user/available-times'
        );
    },
    getAvailableTimeOfUser: async (params?: any): Promise<
        AxiosResponse<ApiResponse<any>>
    > => {
        return axiosClient.get<ApiResponse<any>>(
            '/available-time',
            { params }
        );
    },
};

export default availableTimeApi;
